import { Reveal } from "./Reveal";
import { PROCESS_STEPS, scrollToId } from "../data/site";

export default function Process() {
  return (
    <section className="bg-[#0A0A0A] py-20 lg:py-28">
      <div className="container-x">
        <Reveal className="mb-14 max-w-2xl">
          <div className="eyebrow mb-4">HOW IT WORKS</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95]">
            Four steps. <span className="text-gradient">Zero stress.</span>
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {PROCESS_STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.1}>
              <div data-testid={step.testid} className="relative group">
                <div className="font-tech text-sm text-[#FF6B00] mb-3 flex items-center gap-3">
                  <span className="w-8 h-px bg-gradient-to-r from-[#FF2A2A] to-[#FF6B00]" />
                  STEP
                </div>
                <div className="font-display text-7xl font-black outline-text leading-none mb-4 group-hover:[-webkit-text-stroke-color:rgba(255,107,0,0.6)] transition-all duration-300">
                  {step.num}
                </div>
                <h3 className="font-display text-2xl font-extrabold uppercase tracking-wide mb-3">{step.title}</h3>
                <p className="text-zinc-500 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3} className="mt-14">
          <button data-testid="process-quote-button" onClick={() => scrollToId("quote")} className="btn-primary">
            START WITH STEP 01 — GET A FREE QUOTE
          </button>
        </Reveal>
      </div>
    </section>
  );
}
